import templateList from './templateList.vue'
import ruleList from './ruleList.vue'
import ruleSplitList from './ruleSplitList.vue'
import splitList from './splitList.vue'
import splitTemplate from './splitTemplate.vue'
import addTemplate from './addTemplate.vue'
import addRule from './addRule.vue'
import addSplitRule from './addSplitRule.vue'
import modifyTemplate from './modifyTemplate.vue'
import modifySplit from './modifySplit.vue'

export default {
	templateList,
	ruleList,
	ruleSplitList,
	splitList,
	splitTemplate,
	addTemplate,
	addRule,
	addSplitRule,
	modifyTemplate,
	modifySplit,
}


// WEBPACK FOOTER //
// ./src/components/template/index.js